<template>
  <span>
    <v-navigation-drawer
      app
      v-model="drawer"
      class="orange-logo"
      dark
      disable-resize-watcher
    >
      <v-list dense>
        <v-list-item href="/">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="/our-story">
          <v-list-item-action>
            <v-icon>mdi-book</v-icon>
          </v-list-item-action>
          <v-list-item-content to="/our-story">
            <v-list-item-title>Our Story</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="/sign-up">
          <v-list-item-action>
            <v-icon>mdi-pencil-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content to="/our-story">
            <v-list-item-title>Sign Up</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed app class="grey lighten-2">
      <v-app-bar-nav-icon
        class="hidden-md-and-up dark"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <v-toolbar-title
        ><a href="/"><img class="logo" src="../assets/logo-200x200.png"/></a
      ></v-toolbar-title>
      <v-btn text class="hidden-sm-and-down" to="/our-story">Our Story</v-btn>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-btn color="orange darken-3" class="hidden-sm-and-down" to="/sign-up"
        >SIGN UP</v-btn
      >
    </v-app-bar>
  </span>
</template>
<script>
export default {
  name: 'AppNavigation',
  data() {
    return {
      appTitle: 'Upload Festival 2020',
      drawer: false,
      items: [{ title: 'Menu' }, { title: 'Sign In' }, { title: 'Join' }]
    };
  }
};
</script>

<style scoped>
.orange-logo {
  background-color: #ff914d !important;
}
.v-btn {
  margin: 0 10px;
}
.logo {
  width: 100px;
}
</style>
